// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from '/data1/jenkins/workspace/aplus_tiger_h5_game_details_share_page_202204251659490524a1d2-5835-4a76-a8b1-7acfca817b0e_tiger-platform_gamecenter_h5_game_details_share_page_20220425165949_48687_nodejs_prod@2/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/index.html",
    "exact": true,
    "component": require('@/pages/index.tsx').default
  },
  {
    "path": "/",
    "exact": true,
    "component": require('@/pages/index.tsx').default
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
